<template>
  <div style="width: 100%">
    <v-tabs v-model="tab" class="tab-event">
      <v-tabs-slider color="#3be287"></v-tabs-slider>
      <v-tab v-for="item in tabItems" :key="item">{{ item }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="item in tabItems" :key="item">
        <v-container v-if="item === 'info'" class="card-container-info">
          <v-row style="margin-top: 10px">
            <v-col
              ><v-row
                ><p class="info-data">Event type :&nbsp;</p>
                <p class="value-data"></p>
                Orbit Insertion</v-row
              >
              <v-row
                ><p class="info-data">Detection date :&nbsp;</p>
                <p class="value-data">
                  {{
                    getDisplayValueFromPath(
                      orbitInsertionInfoEvent.detectionDate,
                      ['detectionDate'],
                      'AbstractEvent'
                    )
                  }}
                </p></v-row
              ></v-col
            >
            <v-divider vertical></v-divider>
            <v-col
              ><v-row
                ><p class="info-data">Norad ID target :&nbsp;</p>
                <p class="value-data"></p>
                {{
                  getDisplayValueFromPath(
                    orbitInsertionInfoEvent.eventTargetNoradId,
                    ['eventTargetNoradId'],
                    'AbstractEvent'
                  )
                }}</v-row
              >
              <v-row
                ><p class="info-data">Norad ID chaser :&nbsp;</p>
                <p class="value-data">
                  {{
                    getDisplayValueFromPath(
                      orbitInsertionInfoEvent.chaserNoradId,
                      ['chaserNoradId'],
                      'AbstractEvent'
                    )
                  }}
                </p></v-row
              ></v-col
            >
            <v-divider vertical></v-divider>
            <v-col
              ><v-row
                ><p class="info-data">SMA (km) :&nbsp;</p>
                <p class="value-data"></p>
                {{
                  getDisplayValueFromPath(
                    orbitInsertionInfoEvent.semiMajorAxisDifferenceAtDetection,
                    ['semiMajorAxisDifferenceAtDetection'],
                    'AbstractEvent'
                  )
                }}</v-row
              >
              <v-row
                ><p class="info-data">Relative inclinaison (deg) :&nbsp;</p>
                <p class="value-data">
                  {{
                    getDisplayValueFromPath(
                      orbitInsertionInfoEvent.relativeInclinationAtDetection,
                      ['relativeInclinationAtDetection'],
                      'AbstractEvent'
                    )
                  }}
                </p></v-row
              ></v-col
            >
          </v-row>

          <v-row>
            <v-col>
              <span class="text-h6">Target TLE</span>
              <TLEDecoder
                :tle="
                  orbitInsertionInfoEvent.targetEventTle
                    .split('\n')
                    .map((line) => line.trim())
                "
                :isExpanded="false"
                :expandDisabled="false"
                :textboxReadonly="true"
              ></TLEDecoder>
            </v-col>
            <v-col>
              <span class="text-h6">Chaser TLE</span>
              <TLEDecoder
                :tle="
                  orbitInsertionInfoEvent.chaserEventTle
                    .split('\n')
                    .map((line) => line.trim())
                "
                :isExpanded="false"
                :expandDisabled="false"
                :textboxReadonly="true"
              ></TLEDecoder>
            </v-col> </v-row
        ></v-container>
        <v-container v-if="item === 'graph'"> </v-container></v-tab-item
    ></v-tabs-items>
  </div>
</template>

<script>
import ScreeningCatalogueAnalysisEventsCesiumVisualizer from './ScreeningCatalogueAnalysisEventsCesiumVisualizer.vue'
import * as Cesium from 'cesium'
import TLEDecoder from '../../components/Toolbox/TLEDecoder'
import defense from '../../mixins/defense'
export default {
  name: 'ScreeningCatalogueAnalysisEventsOrbitInsertionVisualizer',
  props: {
    orbitInsertionInfoEvent: {
      type: Object
    }
  },
  components: {
    ScreeningCatalogueAnalysisEventsCesiumVisualizer,
    TLEDecoder
  },
  mixins: [defense],
  data() {
    return {
      dialog: false,
      satellitesDatas: [],
      timelineDates: [],
      textDescription:
        'The orbit insertion displays the orbits of both objects. From the moment that an orbit insertion has been detected, the position of both objects are propagated both in the past and in the future to give a better visual overview of the situation.',
      tabItems: ['info', 'graph'],
      tab: null
    }
  },
  watch: {
    orbitInsertionInfoEvent() {
      this.updateDatas()
    }
  },
  computed: {},
  mounted() {
    this.updateDatas()
  },
  methods: {
    async updateDatas() {
      this.satellitesDatas = []
      this.timelineDates = []
      const startDate = this.turnBackDate(
        this.orbitInsertionInfoEvent.detectionDate,
        4,
        'hours'
      )
      const endDate = this.advanceDate(
        this.orbitInsertionInfoEvent.detectionDate,
        4,
        'hours'
      )

      const previousSatIsTarget =
        this.orbitInsertionInfoEvent.previousTleIsTarget
      this.satellitesDatas.push(
        await this.getDataSatellite({
          name: 'Target',
          color: Cesium.Color.GREEN,
          tle: this.orbitInsertionInfoEvent.targetEventTle
            .split('\n')
            .map((line) => line.trim()),
          startDate: previousSatIsTarget
            ? this.orbitInsertionInfoEvent.detectionDate
            : startDate,
          endDate: endDate,
          stepInSeconds: 5,
          orbitLine: true,
          pointsPlanes: [],
          pointsLines: null
        })
      )
      this.satellitesDatas.push(
        await this.getDataSatellite({
          name: 'Chaser',
          color: Cesium.Color.RED,
          tle: this.orbitInsertionInfoEvent.chaserEventTle
            .split('\n')
            .map((line) => line.trim()),
          startDate: previousSatIsTarget
            ? startDate
            : this.orbitInsertionInfoEvent.detectionDate,
          endDate: endDate,
          stepInSeconds: 5,
          orbitLine: true,
          pointsPlanes: [],
          pointsLines: null
        })
      )
      this.satellitesDatas.push(
        await this.getDataSatellite({
          name: previousSatIsTarget ? 'PreviousTarget' : 'PreviousChaser',
          color: previousSatIsTarget ? Cesium.Color.GREEN : Cesium.Color.RED,
          tle: this.orbitInsertionInfoEvent.previousTle
            .split('\n')
            .map((line) => line.trim()),
          startDate: startDate,
          endDate: this.orbitInsertionInfoEvent.detectionDate,
          stepInSeconds: 5,
          orbitLine: true,
          pointsPlanes: [],
          pointsLines: null
        })
      )

      this.timelineDates.push({
        color: 'blue',
        tooltip: 'Start Date',
        date: startDate
      })
      this.timelineDates.push({
        color: 'red',
        tooltip: 'Detection Date',
        date: this.orbitInsertionInfoEvent.detectionDate
      })
      this.timelineDates.push({
        color: 'blue',
        tooltip: 'End Date',
        date: endDate
      })
      this.sendDatasForCesium({
        satellitesDatas: this.satellitesDatas,
        timelineDates: this.timelineDates,
        textDescription: this.textDescription
      })
    },
    sendDatasForCesium(item) {
      this.$emit('cesium-visualizer-method', item)
    }
  }
}
</script>
<style scoped>
.info-data {
  font-weight: bold;
  margin-left: 15px;
}
.card-container-info {
  height: 475px;
  overflow-y: scroll;
  scrollbar-width: none;
}
</style>
